import Intercom, {
  boot as bootIntercom,
  shutdown as shutdownIntercom,
  update as updateIntercom,
} from '@intercom/messenger-js-sdk'

export type IntercomUserData = {
  user_id: string
  name: string
  email?: string
  phone?: string
  company: {
    company_id?: string
    name?: string
  }
}

class IntercomService {
  private isScriptLoaded = false

  public isEnabled() {
    return Boolean(process.env.REACT_APP_INTERCOM_APP_ID)
  }

  private getIdentifiedSettings(userData: IntercomUserData) {
    return {
      app_id: process.env.REACT_APP_INTERCOM_APP_ID as string,
      hide_default_launcher: false,
      ...userData,
    }
  }

  public identifyUser(userData: IntercomUserData) {
    if (!this.isEnabled()) {
      return
    }

    const settings = this.getIdentifiedSettings(userData)

    if (!this.isScriptLoaded) {
      Intercom({
        region: 'us',
        ...settings,
      })

      this.isScriptLoaded = true

      return
    }

    bootIntercom(settings)
  }

  public updateIdentifiedUser(userData: IntercomUserData) {
    if (!this.isEnabled()) {
      return
    }

    updateIntercom(this.getIdentifiedSettings(userData))
  }

  public shutdownOnLogout() {
    if (!this.isEnabled() || !this.isScriptLoaded) {
      return
    }

    shutdownIntercom()
  }
}

export const intercomService = new IntercomService()
